// src/OnboardingForm.js
import React, { useState } from "react";
import { useAuth } from "./AuthContext";

export default function OnboardingForm() {
  const { user, token } = useAuth();
  const [form, setForm] = useState({
    full_name: "",
    email: user?.email || "",
    country: "",
    region: "",
    district: "",
    village: "",
    gps_lat: "",
    gps_lng: "",
    aggregator_id: "",
  });
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setMessage("");

    try {
      const response = await fetch("/api/farmers", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          full_name: form.full_name,
          email: form.email || user?.email || "",
          country: form.country,
          region: form.region,
          district: form.district,
          village: form.village,
          gps_lat: numOrU(form.gps_lat),
          gps_lng: numOrU(form.gps_lng),
          aggregator_id: form.aggregator_id || "",
          created_by: user?.email || "",
          verified: false,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to save");
      }

      setMessage("✓ Farmer profile saved successfully!");
      setForm((f) => ({
        ...f,
        full_name: "", 
        country: "", 
        region: "", 
        district: "", 
        village: "",
        gps_lat: "", 
        gps_lng: "",
        aggregator_id: ""
      }));
    } catch (err) {
      setMessage("✗ Error: " + err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card">
      <h2 style={{ marginTop: 0 }}>Farmer Onboarding</h2>
      
      {message && (
        <div style={{
          padding: "12px",
          marginBottom: "16px",
          borderRadius: "4px",
          background: message.startsWith("✓") ? "#10b981" : "#ef4444",
          color: "white"
        }}>
          {message}
        </div>
      )}

      <form onSubmit={onSubmit}
            style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap: 12 }}>
        <label>Full name<br/><input name="full_name" value={form.full_name} onChange={onChange} required /></label>
        <label>Email<br/><input name="email" type="email" value={form.email}
                                onChange={onChange} placeholder={user?.email || "farmer@example.com"} /></label>
        <label>Country<br/><input name="country" value={form.country} onChange={onChange} required /></label>
        <label>Region<br/><input name="region" value={form.region} onChange={onChange} /></label>
        <label>District<br/><input name="district" value={form.district} onChange={onChange} /></label>
        <label>Village<br/><input name="village" value={form.village} onChange={onChange} /></label>
        <label>GPS lat<br/><input name="gps_lat" value={form.gps_lat} onChange={onChange} placeholder="e.g. -1.286389" /></label>
        <label>GPS lng<br/><input name="gps_lng" value={form.gps_lng} onChange={onChange} placeholder="e.g. 36.817223" /></label>
        <label>Aggregator ID<br/><input name="aggregator_id" value={form.aggregator_id} onChange={onChange} /></label>
        <div style={{ alignSelf: "end" }}>
          <button type="submit" disabled={busy}>{busy ? "Saving…" : "Save profile"}</button>
        </div>
      </form>
    </div>
  );
}

function numOrU(v) {
  if (v === "" || v == null) return undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
}